import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.function.name";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _ from 'lodash';
import React from 'react';
import { compose, branch, toClass, setDisplayName } from 'recompose';
var fakeUuid = 0;

function uuid() {
  // NOTE: during tests we want to use deterministic uuids, so that
  // snapshot testing can still be useful!
  return process.env.NODE_ENV === 'test' ? ++fakeUuid : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (a) {
    return (a ^ Math.random() * 16 >> a / 4).toString(16);
  });
}

var defaultSegments = {
  wrapper: [],
  container: [],
  input: []
};
var keyboards = {
  decimal: {
    type: 'number',
    pattern: '[0-9]+([,.][0-9]+)?',
    step: '0.01'
  },
  number: {
    type: 'text',
    pattern: '[0-9]*'
  }
};

var InputContainer = function InputContainer(_ref) {
  var type = _ref.type,
      name = _ref.name,
      disabled = _ref.disabled,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      setRef = _ref.setRef,
      Container = _ref.Container,
      Input = _ref.Input,
      containerProps = _ref.containerProps,
      styles = _ref.styles,
      __segments = _ref.__segments,
      children = _ref.children,
      charLimit = _ref.charLimit,
      isSoftLimit = _ref.isSoftLimit,
      showCharLimit = _ref.showCharLimit,
      _ref$Limit = _ref.Limit,
      Limit = _ref$Limit === void 0 ? CharLimit : _ref$Limit,
      inputProps = _objectWithoutProperties(_ref, ["type", "name", "disabled", "prefix", "suffix", "setRef", "Container", "Input", "containerProps", "styles", "__segments", "children", "charLimit", "isSoftLimit", "showCharLimit", "Limit"]);

  var segments = _.defaults(__segments, defaultSegments);

  return React.createElement("div", styles.apply(void 0, ['wrapper'].concat(_toConsumableArray(segments.wrapper))), React.createElement(Container, _extends({}, containerProps, styles.apply(void 0, ['container', {
    disabled: disabled
  }].concat(_toConsumableArray(segments.container))), !_.isString(Container) && {
    styles: styles
  }), prefix && React.createElement("span", styles('prefix'), prefix), React.createElement(Input, _extends({}, _.isString(Input) ? inputProps : _objectSpread({}, inputProps, {
    setRef: setRef
  }), styles.apply(void 0, ['input'].concat(_toConsumableArray(segments.input))), keyboards[type] || {
    type: type
  }, !_.isString(Input) && {
    styles: styles
  }, _.isString(Input) && {
    ref: setRef
  }, {
    id: "".concat(name, "-").concat(uuid()) // NOTE: this disables chrome autofill (atm), ideally we can make
    // this an option at some point!
    ,
    name: "".concat(name, "-").concat(uuid()),
    autoComplete: uuid() // ENDNOTE
    ,
    disabled: disabled,
    maxLength: isSoftLimit ? undefined : charLimit
  })), suffix && React.createElement("span", styles('suffix'), suffix)), showCharLimit && charLimit && React.createElement(Limit, {
    limit: charLimit,
    length: _.get(inputProps, 'value', '').length,
    styles: styles
  }), children);
};

var CharLimit = function CharLimit(_ref2) {
  var length = _ref2.length,
      limit = _ref2.limit,
      styles = _ref2.styles;
  return React.createElement("div", styles('charLimitContainer'), React.createElement("span", styles({
    charLimitReached: length && length >= limit,
    charLimitExceeded: length && length > limit
  }), length || 0), "/", limit);
};

var withBackingInstance = compose(setDisplayName('behaviour(BackingInstance)'), branch(function (_ref3) {
  var setRef = _ref3.setRef;
  return _.isFunction(setRef);
}, toClass));
export default withBackingInstance(InputContainer);